<template>
  <div class="flex flex-wrap justify-evenly">
    <div
      v-for="priority in priorities"
      :key="priority.value"
      v-tooltip="capitalize(priority.value)"
      :data-cy="`priority-${priority.value}`"
      class="mr-2 mb-1 flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-grey-hover"
      :class="[
        {
          'border border-primary': priority.value === modelValue,
        },
        isInboxPage ? 'h-10 w-10' : 'h-8 w-8',
      ]"
      @click="setPriority(priority.value)"
    >
      <div>
        <icon-base
          height="15"
          width="15"
          :view-box="priority.viewBox"
          :class="priority.class"
          :icon="priority.icon"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
interface Props {
  modelValue: string;
}
</script>

<script setup lang="ts">
import capitalize from "lodash/capitalize";

import { priorities } from "@/helpers/constants/communicationLogs";
import { useCommunicationLogs } from "@/hooks/communicationLogs";

const emit = defineEmits<{
  "update:model-value": [value: string];
}>();
defineProps<Props>();

const { isInboxPage } = useCommunicationLogs();

const setPriority = (priority: string) => {
  emit("update:model-value", priority);
};
</script>
